import axios from "axios";

// Create Axios instance
const axiosInstance = axios.create({
  baseURL: "http://192.168.1.9:8000",
  timeout: 100000,
});

// Add request Interceptor
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    // console.log(token);
    // console.log(config.headers);

    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// axios.interceptors.response.use((response) => {
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject(error),
);

export default axiosInstance;

// axiosInstance.interceptors.response.use((response) => {
//   // console.log("✅ Axios Response:", response);
//   return response; // ✅ you must return the response
// });

// type Payload = Record<string, any> | null;

// const AXIOSCONFIGMETHOD = async (
//   method: string,
//   url: string,
//   payload: Payload = null,
//   headers: Record<string, string> = {}
// ) => {
//   try {
//     const token = "your-authentication-token"; // Replace with dynamic token logic if needed

//     const config = {
//       headers: {
//         ...headers,
//         Authorization: `Bearer ${token}`,
//       },
//     };

//     const resp = await axios({
//       method,
//       url,
//       data: payload,
//       ...config,
//     });
//     console.log("🚀 AXIOS RESPONSE:", resp); // Add this

//     if (
//       resp?.data &&
//       (Array.isArray(resp.data) || resp.data.success === undefined)
//     ) {
//       console.log(resp);
//       return {
//         success: true,
//         data: resp.data,
//         message: "Request successful",
//       };
//     }

//     if (resp?.data?.success) {
//       return resp.data;
//     } else {
//       throw {
//         response: {
//           data: {
//             message: resp.data.message || "Request unsuccessful",
//             errors: resp.data.errors || [],
//           },
//         },
//       };
//     }
//   } catch (error: any) {
//     console.error("AXIOS ERROR:", error);

//     throw {
//       message:
//         error.response?.data?.message ||
//         error.message ||
//         "An unexpected error occurred",
//       errors: error.response?.data?.errors || [],
//       status: error.response?.status || 500,
//     };
//   }
// };
// export default AXIOSCONFIGMETHOD;
